import { DetailedInvoiceType } from 'b2b-common/core/account/api/invoices';
import { CLEAR_ACCOUNT_INVOICE, FETCH_INVOICE, FETCH_INVOICE_FULFILLED, FETCH_INVOICE_REJECTED } from './actionTypes';
import {
  ClearAccountInvoiceAction,
  FetchInvoiceAction,
  FetchInvoiceFulfilledAction,
  FetchInvoiceRejectedAction,
} from './types';

const fetchInvoice = (invoiceId: string): FetchInvoiceAction => ({
  type: FETCH_INVOICE,
  payload: {
    invoiceId,
  },
});

const fetchInvoiceFulfilled = (invoiceId: string, response: DetailedInvoiceType): FetchInvoiceFulfilledAction => ({
  type: FETCH_INVOICE_FULFILLED,
  payload: {
    invoiceId,
    data: response,
  },
});

const fetchInvoiceRejected = (invoiceId: string, error: ErrorType): FetchInvoiceRejectedAction => ({
  type: FETCH_INVOICE_REJECTED,
  payload: {
    invoiceId,
    error,
  },
});

const clearAccountInvoice = (): ClearAccountInvoiceAction => ({
  type: CLEAR_ACCOUNT_INVOICE,
});

export {
  clearAccountInvoice,
  fetchInvoice,
  fetchInvoiceFulfilled,
  fetchInvoiceRejected,
};
